export type IDatepickers = IDCA.IGenericFunc;

export function _datepickers(): void {
  $('.accessible-datepicker-input').each((_, elm) => {
    const $elm = $(elm);
    // If datepicker is already initialized, exit
    if ($elm.data('datepicker')) {
      return;
    }
    const pickerOnly = $elm.data('picker-only');
    const $inputGroup = $elm.parent('.input-group');
    const $triggerButton = $inputGroup.find('.date-picker-trigger');
    const fieldInputName = $elm.attr('name');
    const readonly = $elm.is('[readonly]') || $elm.is('[disabled]');
    const options = {
      callBackFn: $elm.data('callback') || false,
      showTime: $elm.data('show-time') || false,
      yearRange: $elm.data('year-range') || false,
    };

    const datePickerID = $inputGroup.siblings('.accessible-datepicker').attr('id');
    // Need to convert datepicker to a class to avoid having to use any
    const datepicker = new (window.AccessibleDatePickerModule.accessibleDatePicker as any)(
      datePickerID,
      fieldInputName,
      options
    );
    $elm.data('datepicker', datepicker);
    if (pickerOnly && !readonly) {
      $elm.attr('readonly', 'true');
    }
    if (!readonly) {
      $triggerButton.click((e) => {
        datepicker.showDlg();
        e.stopPropagation();
        return false;
      });
    }
  });
}
